export default __webpack_public_path__ + "static/media/cartoon-modal-bg.51976653.svg";